import axios from "../../axios.js";

const setNullToReports = async ({ commit }) => {
  commit("SET_VERIFIED_USERS_REPORT", []);
  commit("SET_DATE_OF_BIRTH_REPORT", []);
  commit("SET_WORK_STATUS_REPORT", []);
  commit("SET_USER_SERVICES_REPORT", []);
  commit("SET_USER_SERVICES_VERIFIED_REPORT", []);
  commit("SET_USER_SERVICES_PRICE_REPORT", []);
  commit("SET_LOCATION_REPORT", []);
  commit("SET_ORDERS_REPORT", []);
  commit("SET_ORDERS_CRS_REPORT", []);
  commit("SET_PAYMENT_TYPES_REPORT", []);
  commit("SET_PAYMENT_TYPES_AMOUNTS_REPORT", []);
  commit("SET_SERVICE_SEARCH_REPORT", []);
  commit("SET_REFERRAL_CODES_REPORT", []);
  commit("SET_USER_SERVICES_IN_SPECIFIED_CITY_REPORT", []);
  commit("SET_PROMOTIONAL_CODES_REPORT", []);
  commit("SET_TOTAL_USERS_AND_USER_SERVICES_REPORT", []);
  commit("SET_USER_REGULATIONS_REPORT", []);
  commit("SET_USERS_ACTIVITY_REPORT", []);
  commit("SET_ADMIN_PERMISSION_SETTINGS_REPORT", []);
  commit("SET_RECHARGES_REPORT", []);
  commit("SET_WALLET_BALANCES_REPORT", []);
  commit("SET_PROFILE_FEATURES_REPORT", []);
  commit("SET_LANGUAGES_REPORT", []);
  commit("SET_TRAININGS_REPORT", []);
  commit("SET_CVS_REPORT", []);
};
const fetchReport = async ({ commit }, data) => {
  const url = `/api/admin/reports?report_type=${data.type}`;

  if (data.type === "VERIFIED_USERS") {
    await axios.get(url).then((response) => {
      commit("SET_VERIFIED_USERS_REPORT", response.data);
    });
  }
  if (data.type === "REFERRAL_CODES") {
    await axios.get(url).then((response) => {
      commit("SET_REFERRAL_CODES_REPORT", response.data);
    });
  }
  if (data.type === "DATE_OF_BIRTH") {
    await axios.get(url).then((response) => {
      commit("SET_DATE_OF_BIRTH_REPORT", response.data);
    });
  }
  if (data.type === "WORK_STATUS") {
    await axios.get(url).then((response) => {
      commit("SET_WORK_STATUS_REPORT", response.data);
    });
  }
  if (data.type === "USER_SERVICES") {
    await axios.get(url).then((response) => {
      commit("SET_USER_SERVICES_REPORT", response.data);
    });
  }
  if (data.type === "SERVICE_SEARCH") {
    await axios.get(url).then((response) => {
      commit("SET_SERVICE_SEARCH_REPORT", response.data);
    });
  }
  if (data.type === "USER_SERVICES_VERIFIED") {
    await axios.get(url).then((response) => {
      commit("SET_USER_SERVICES_VERIFIED_REPORT", response.data);
    });
  }
  if (data.type === "USER_SERVICES_PRICE") {
    await axios.get(url).then((response) => {
      commit("SET_USER_SERVICES_PRICE_REPORT", response.data);
    });
  }
  if (data.type === "LOCATION") {
    await axios.get(url).then((response) => {
      commit("SET_LOCATION_REPORT", response.data);
    });
  }
  if (data.type === "LOCATION_CITY") {
    await axios.get(url).then((response) => {
      commit("SET_LOCATION_CITY_REPORT", response.data);
    });
  }
  if (data.type === "ORDERS") {
    await axios.get(url).then((response) => {
      commit("SET_ORDERS_REPORT", response.data);
    });
  }
  if (data.type === "ORDERS_CRS") {
    await axios.get(url).then((response) => {
      commit("SET_ORDERS_CRS_REPORT", response.data);
    });
  }
  if (data.type === "PAYMENT_TYPES") {
    await axios.get(url).then((response) => {
      commit("SET_PAYMENT_TYPES_REPORT", response.data);
    });
  }
  if (data.type === "PAYMENT_TYPES_AMOUNTS") {
    await axios.get(url).then((response) => {
      commit("SET_PAYMENT_TYPES_AMOUNTS_REPORT", response.data);
    });
  }
};

const fetchUserServicesInSpecifiedCityReport = async ({ commit }) => {
  const url = `/api/admin/employeesInSpecificArea`;
  await axios.get(url).then((response) => {
    commit("SET_USER_SERVICES_IN_SPECIFIED_CITY_REPORT", response.data);
  });
};
const fetchTotalUserAndUserServicesReport = async ({ commit }) => {
  const url = `/api/admin/totalUsersAndUserServices/report`;
  await axios.get(url).then((response) => {
    commit("SET_TOTAL_USERS_AND_USER_SERVICES_REPORT", response.data);
  });
};
const fetchPromotionalCodesReport = async ({ commit }, data) => {
  const url = `/api/admin/promotionalCodes/report?only_used=${data.only_used}`;
  await axios.get(url).then((response) => {
    commit("SET_PROMOTIONAL_CODES_REPORT", response.data);
  });
};

const fetchOrdersRejectionReport = async ({ commit }, data) => {
  const auto_rejected = data.auto_rejected ? true : false;
  const user_rejected = data.user_rejected ? true : false;
  const url = `/api/admin/rejectedOrders/report?auto_rejected=${auto_rejected}&user_rejected=${user_rejected}`;
  await axios.get(url).then((response) => {
    commit("SET_ORDERS_REJECTION_REPORT", response.data);
  });
};
const fetchUserRegulationsReport = async ({ commit }, data) => {
  const onPage = data && data.on_page ? data.on_page : 20;
  const pageNumber = data && data.page_number ? data.page_number : 1;
  const url = `/api/admin/userRegulations?on_page=${onPage}&page_number=${pageNumber}`;
  await axios
    .get(url)
    .then((response) => {
      commit("SET_USER_REGULATIONS_REPORT", response.data);
    })
    .catch((error) => {
      console.log(error);
    });
};

const fetchServiceRegulationsReport = async ({ commit }, data) => {
  const onPage = data && data.on_page ? data.on_page : 20;
  const pageNumber = data && data.page_number ? data.page_number : 1;
  const url = `/api/admin/userServicesRegulations?on_page=${onPage}&page_number=${pageNumber}`;
  await axios
    .get(url)
    .then((response) => {
      commit("SET_SERVICE_REGULATIONS_REPORT", response.data);
    })
    .catch((error) => {
      console.log(error);
    });
};

const fetchUsersActivityReport = async ({ commit }) => {
  const url = `/api/admin/userActivityMonthly`;
  await axios
    .get(url)
    .then((response) => {
      commit("SET_USERS_ACTIVITY_REPORT", response.data);
    })
    .catch((error) => {
      console.log(error);
    });
};
const fetchAdminPermissionSettingsReport = async ({ commit }) => {
  const url = `/api/admin/permissionSettings`;
  await axios
    .get(url)
    .then((response) => {
      commit("SET_ADMIN_PERMISSION_SETTINGS_REPORT", response.data);
    })
    .catch((error) => {
      console.log(error);
    });
};
const fetchRechargesReport = async ({ commit }) => {
  const url = `/api/admin/rechargeReport/report`;
  await axios
    .get(url)
    .then((response) => {
      commit("SET_RECHARGES_REPORT", response.data);
    })
    .catch((error) => {
      console.log(error);
    });
};

const fetchWalletBalancesReport = async ({ commit }) => {
  const url = `/api/admin/walletBalancesReport/report`;
  await axios
    .get(url)
    .then((response) => {
      commit("SET_WALLET_BALANCES_REPORT", response.data);
    })
    .catch((error) => {
      console.log(error);
    });
};

const fetchHealthDataConsentsReport = async () => {
  const response = await axios.get("/api/admin/healthDataConsentsReport");
  return response.data;
};

const fetchProfileElementsReport = async ({ commit }, data) => {
  const { type } = data;
  let params = {};
  if (data.service_category_display_name) {
    params.service_category_display_name = data.service_category_display_name;
  }
  if (data.service_subcategory_display_name) {
    params.subcategory_display_name = data.service_subcategory_display_name;
  }
  if (data.service_display_name) {
    params.service_display_name = data.service_display_name;
  }
  if (data.city) {
    params.city = data.city;
  }
  const url = `/api/admin/profileElementsReport?type=${type}`;
  await axios
    .get(url, { params })
    .then((response) => {
      if (type === "PROFILE_FEATURE") {
        commit("SET_PROFILE_FEATURES_REPORT", response.data);
      }
      if (type === "LANGUAGES") {
        commit("SET_LANGUAGES_REPORT", response.data);
      }
      if (type === "TRAINING") {
        commit("SET_TRAININGS_REPORT", response.data);
      }
      if (type === "CVS") {
        commit("SET_CVS_REPORT", response.data);
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

const fetchSmsReport = async ({ commit }) => {
  try {
    const url = `/api/admin/smses/report`;
    const response = await axios.get(url);
    commit("SET_SMS_REPORT", response.data);
  } catch (error) {
    console.log(error);
    commit("SET_SMS_REPORT", []);
  }
};

const fetchUsersAndOrdersReport = async ({ commit }) => {
  try {
    const url = `/api/admin/usersAndOrders/report`;
    const response = await axios.get(url);
    commit("SET_USERS_AND_ORDERS_REPORT", response.data);
  } catch (error) {
    console.log(error);
    commit("SET_USERS_AND_ORDERS_REPORT", []);
  }
};

const fetchOrdersByStatusReport = async ({ commit }) => {
  try {
    const url = `/api/admin/ordersByStatus/report`;
    const response = await axios.get(url);
    commit("SET_ORDERS_BY_STATUS_REPORT", response.data);
  } catch (error) {
    console.log(error);
    commit("SET_ORDERS_BY_STATUS_REPORT", []);
  }
};

const fetchUsersServicesByCityReport = async ({ commit }, data) => {
  try {
    const url = `/api/admin/verifiedUsersByCity/report`;
    let params = {};
    if (data.service_category_display_name) {
      params.service_category_display_name = data.service_category_display_name;
    }
    if (data.service_subcategory_display_name) {
      params.subcategory_display_name = data.service_subcategory_display_name;
    }
    if (data.service_display_name) {
      params.service_display_name = data.service_display_name;
    }
    if (data.city) {
      params.city = data.city;
    }
    const response = await axios.get(url, { params });

    commit("SET_USERS_SERVICES_BY_CITY_REPORT", response.data);
  } catch (error) {
    console.log(error);
    commit("SET_USERS_SERVICES_BY_CITY_REPORT", []);
  }
};

const fetchDatabaseTables = async ({ commit }) => {
  try {
    const url = `/api/admin/database-tables`;
    const response = await axios.get(url);
    commit("SET_DATABASE_TABLES", response.data);
  } catch (e) {
    console.log(e);
    commit("SET_DATABASE_TABLES", []);
  }
};
const generateSqlReport = async ({ commit }, data) => {
  try {
    const { sql } = data;
    const url = `/api/admin/database-tables/report`;
    const response = await axios.post(url, { sql });
    commit("SET_SQL_REPORT", response.data);
    return true;
  } catch (e) {
    console.log(e);
    commit("SET_SQL_REPORT", []);
    return false;
  }
};

const fetchSqlReportNote = async ({ commit }) => {
  try {
    const url = `/api/reportNotes`;
    const response = await axios.get(url);
    if (response) {
      commit("SET_SQL_REPORT_NOTE", response.data);
      return true;
    }
  } catch (e) {
    console.log(e);
    commit("SET_SQL_REPORT", []);
    return false;
  }
};

const fetchUsersReportsFromAppReport = async ({ commit }) => {
  try {
    const url = `/api/admin/usersReports/report`;
    const response = await axios.get(url, {});

    commit("SET_USERS_REPORTS_FROM_APP_REPORT", response.data);
  } catch (error) {
    console.log(error);
    commit("SET_USERS_REPORTS_FROM_APP_REPORT", []);
  }
};

const fetchDodBillsReport = async ({ commit }, { year, month }) => {
  try {
    const url = `/api/admin/dodBillsReport/report`;
    const response = await axios.get(url, { params: { year, month } });
    commit("SET_DOD_BILLS_REPORT", response.data);
  } catch (error) {
    console.log(error);
    commit("SET_DOD_BILLS_REPORT", []);
  }
};

const fetchInvoicesReport = async ({ commit }, { year, month }) => {
  try {
    const url = `/api/admin/invoicesReport/report`;
    const response = await axios.get(url, { params: { year, month } });
    commit("SET_INVOICES_REPORT", response.data);
  } catch (error) {
    console.log(error);
    commit("SET_INVOICES_REPORT", []);
  }
};

const verifyInvoicesReport = async ({ commit }, { year, month }) => {
  try {
    const url = `/api/admin/invoicesReport/verify`;
    const response = await axios.get(url, { params: { year, month } });
    commit("MERGE_INVOICES_VERIFY", response.data);
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

const editSqlReportNote = async ({ commit }, data) => {
  try {
    const { text } = data;
    const url = `/api/reportNotes`;
    const response = await axios.put(url, { text });
    if (response) {
      commit("SET_SQL_REPORT_NOTE", response.data);
      return true;
    } else {
      return false;
    }
  } catch (e) {
    console.log(e);
    commit("SET_SQL_REPORT", []);
    return false;
  }
};

export default {
  fetchReport,
  setNullToReports,
  fetchUserServicesInSpecifiedCityReport,
  fetchTotalUserAndUserServicesReport,
  fetchPromotionalCodesReport,
  fetchOrdersRejectionReport,
  fetchUserRegulationsReport,
  fetchUsersActivityReport,
  fetchAdminPermissionSettingsReport,
  fetchRechargesReport,
  fetchWalletBalancesReport,
  fetchProfileElementsReport,
  fetchHealthDataConsentsReport,
  fetchServiceRegulationsReport,
  fetchSmsReport,
  fetchUsersAndOrdersReport,
  fetchOrdersByStatusReport,
  fetchUsersServicesByCityReport,
  fetchUsersReportsFromAppReport,
  fetchDodBillsReport,
  fetchInvoicesReport,
  verifyInvoicesReport,
  fetchDatabaseTables,
  generateSqlReport,
  fetchSqlReportNote,
  editSqlReportNote,
};
